module.exports = __webpack_public_path__ + "static/media/HighScoreBoy.7f5f5f36.svg";